export default __webpack_public_path__ + "static/media/jazzCash.9ef993d1.svg";